import { createPlugin } from "../createPlugin";
import { PlayerEvent } from "../../Core/PlayerEvents";

/**
 * Multiple audio track plugin — native AudioTrackList + config metadata.
 * Refreshes after source/metadata so HLS/native tracks appear after load.
 */
export function createAudioTracksPlugin(options) {
  options = options || {};

  return createPlugin({
    name: "audio-tracks",
    version: "0.1.1",
    onReady: function (ctx) {
      var controller = ctx.tracks;
      if (!controller) {
        return;
      }

      var refresh = function () {
        var configured = options.tracks || ctx.config.audioTracks || [];
        var providerTracks = null;
        if (
          ctx.engine &&
          typeof ctx.engine.getProviderAudioTracks === "function"
        ) {
          providerTracks = ctx.engine.getProviderAudioTracks();
        }
        if (providerTracks && providerTracks.length) {
          controller.setAudioTracks(
            configured.concat(
              providerTracks.map(function (t, index) {
                return {
                  id: t.id || "hls-" + index,
                  label: t.label || t.language || "Audio " + (index + 1),
                  language: t.language || "",
                  kind: t.kind || "main",
                  default: !!t.default,
                  source: "hls",
                  hlsIndex: t.index != null ? t.index : index,
                };
              })
            )
          );
        } else {
          controller.setAudioTracks(configured);
        }
        ctx.bus.emit(PlayerEvent.AUDIO_TRACKS_CHANGED, {
          tracks: controller.getAudioTracks(),
          activeId: controller.getActiveAudioTrackId(),
        });
      };

      refresh();

      ctx._audioTrackUnsubs = [
        ctx.engine.on(PlayerEvent.SOURCE_CHANGED, refresh),
        ctx.engine.on("durationchange", refresh),
        ctx.engine.on("canplay", refresh),
      ];

      ctx.bus.on("ui:selectAudioTrack", function (id) {
        controller.selectAudioTrack(id);
        var tracks = controller.getAudioTracks();
        var current = null;
        for (var i = 0; i < tracks.length; i++) {
          if (tracks[i].id === id) {
            current = tracks[i];
            break;
          }
        }
        if (
          current &&
          current.source === "hls" &&
          ctx.engine &&
          typeof ctx.engine.setProviderAudioTrack === "function"
        ) {
          ctx.engine.setProviderAudioTrack(
            current.hlsIndex != null ? current.hlsIndex : id
          );
        }
        ctx.bus.emit(PlayerEvent.AUDIO_TRACK_SELECTED, {
          id: id,
          track: current,
        });
        ctx.bus.emit(PlayerEvent.ANNOUNCEMENT, {
          message:
            "Audio track: " +
            ((current && current.label) || id || "unknown"),
        });
      });
    },
    onDestroy: function (ctx) {
      if (ctx._audioTrackUnsubs) {
        ctx._audioTrackUnsubs.forEach(function (u) {
          if (typeof u === "function") u();
        });
      }
    },
  });
}

export default createAudioTracksPlugin;
